/* eslint-disable react/no-danger */
import React from 'react';
import { graphql } from 'gatsby';
import { get as _get } from 'lodash-es';
import Helmet from 'react-helmet';
import Layout from '../components/Layout';

import PartialsHeader from '../components/Partials/PartialsHeader';
import PartialsQuestion from '../components/Partials/PartialsQuestion';
import ResultBase from '../components/Result/ResultBase';
import ResultTestimonial from '../components/Result/ResultTestimonial';
import ResultsCardSwiperSection from '../components/ResultsCardSwiperSection';

export const CaseStudyTemplate = ({ caseStudy }) => {
  const image = _get(
    caseStudy,
    'frontmatter.images.social.childImageSharp.fixed.src'
  );

  const descriptionDefault = caseStudy.header
    ? `${caseStudy.frontmatter.header.slice(0, 150)}...`
    : '';
  const cleanDescriptionDefault = descriptionDefault.replace(
    /<\/?[^>]+(>|$)/g,
    ''
  );

  const seoTitle =
    caseStudy.frontmatter.seo_title || caseStudy.frontmatter.title;
  const seoDescription =
    caseStudy.frontmatter.seo_desc || cleanDescriptionDefault;

  const dataToChange = [
    {
      caseStudyTitle: 'OpenNFT',
      bannerTitle: 'Want to build your own NFT marketplace?',
      bannerSubtitle: ''
    }
  ];
  const filteredData = dataToChange.filter(
    el => el.caseStudyTitle === caseStudy.frontmatter.title
  )[0];
  const createBanner = updatedData => {
    if (updatedData) {
      return (
        <PartialsQuestion
          title={updatedData.bannerTitle}
          subtitle={updatedData.bannerSubtitle}
        />
      );
    }
    return (
      <PartialsQuestion
        title="And that’s all..."
        subtitle="Now, it’s your turn! Are you excited to start the process and learn more about your journey with Ulam Labs? Don’t hesitate to contact us with your questions."
      />
    );
  };

  const Banner = createBanner(filteredData);

  return (
    <Layout title={seoTitle} description={seoDescription} seoImage={image}>
      <Helmet>
        <meta property="og:type" content="article" />
      </Helmet>
      <PartialsHeader higher>
        <div className="container">
          <div className="content">
            <div className="body">
              <h1 className="title">{caseStudy.frontmatter.title}</h1>
              <div className="row">
                <div className="col-xl-8">
                  <div className="introduction">
                    <div
                      key="header"
                      dangerouslySetInnerHTML={{
                        __html: caseStudy.frontmatter.header
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </PartialsHeader>
      <div className="result-show shorter">
        <ResultBase caseStudy={caseStudy} />
        {!!_get(caseStudy, 'frontmatter.testimonial.author.title') && (
          <ResultTestimonial caseStudy={caseStudy} />
        )}
        {Banner}
        <ResultsCardSwiperSection
          omitByID={caseStudy.id}
          title="Other projects"
        />
      </div>
    </Layout>
  );
};

const CaseStudy = props => {
  const siteUrl = _get(props, 'data.site.siteMetadata.siteUrl');
  const caseStudy = _get(props, 'data.caseStudy', {});
  return <CaseStudyTemplate caseStudy={caseStudy} siteUrl={siteUrl} />;
};

export default CaseStudy;

export const casePageQuery = graphql`
  query casePageQuery($id: String!) {
    site {
      siteMetadata {
        siteUrl
      }
    }
    caseStudy: markdownRemark(id: { eq: $id }) {
      id
      html
      fields {
        url: slug
      }
      frontmatter {
        title
        seo_title
        seo_desc
        published
        date
        header
        info {
          industry
          companySize
          country
          scope
          link {
            url
            text
          }
          responsibilities
          projectDuration
          interested
        }
        technologies {
          sectionLocation
          oneline
          icons
          text
        }
        sections {
          title
          subtitle
          paragraph
          body
          photo {
            childImageSharp {
              fluid(maxWidth: 1100, quality: 100) {
                ...GatsbyImageSharpFluid_withWebp_noBase64
              }
            }
          }
          photoPosition
          lists {
            list
            listType
            listHeader
          }
          banner
          bannerVisible
        }
        images {
          technologies {
            childImageSharp {
              fluid(maxWidth: 550, quality: 100) {
                ...GatsbyImageSharpFluid_withWebp_noBase64
                presentationHeight
              }
            }
          }
          logo {
            childImageSharp {
              fixed(
                duotone: { highlight: "#cccccc", shadow: "#505050", opacity: 0 }
                width: 140
                quality: 100
                pngCompressionSpeed: 10
              ) {
                ...GatsbyImageSharpFixed_withWebp_noBase64
              }
            }
          }
          social {
            childImageSharp {
              fixed(width: 660) {
                src
              }
            }
          }
        }
        testimonial {
          content
          lightMode
          author {
            title
            subtitle
            photo {
              childImageSharp {
                fixed(width: 64, quality: 100, pngCompressionSpeed: 10) {
                  ...GatsbyImageSharpFixed_withWebp_noBase64
                }
              }
            }
          }
        }
      }
    }
  }
`;
